/* eslint-disable max-len */

import { clsx } from 'clsx'
import type { ClassValue } from 'clsx'

type Props = {
  className?: ClassValue
}

export default function Cursor({ className }: Props) {
  return (
    <svg
      className={clsx('h-11 w-11', className)}
      fill="currentColor"
      aria-hidden="true"
      viewBox="0 0 24 24"
    >
      <path d="M11.71 17.99C8.53 17.84 6 15.22 6 12c0-3.31 2.69-6 6-6 3.22 0 5.84 2.53 5.99 5.71l-2.1-.63C15.48 9.31 13.89 8 12 8c-2.21 0-4 1.79-4 4 0 1.89 1.31 3.48 3.08 3.89zM22 12c0 .3-.01.6-.04.9l-1.97-.59c.01-.1.01-.21.01-.31 0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8c.1 0 .21 0 .31-.01l.59 1.97c-.3.03-.6.04-.9.04-5.52 0-10-4.48-10-10S6.48 2 12 2s10 4.48 10 10m-3.77 4.26 2.27-.76c.46-.15.45-.81-.01-.95l-7.6-2.28c-.38-.11-.74.24-.62.62l2.28 7.6c.14.47.8.48.95.01l.76-2.27 3.91 3.91c.2.2.51.2.71 0l1.27-1.27c.2-.2.2-.51 0-.71z"></path>
    </svg>
  )
}
